import Keycloak from 'keycloak-js';

// Фича-флаг: без REACT_APP_KEYCLOAK_URL Keycloak выключен (легаси-вход).
export const keycloakEnabled = !!process.env.REACT_APP_KEYCLOAK_URL;

const keycloak = keycloakEnabled
  ? new Keycloak({
      url: process.env.REACT_APP_KEYCLOAK_URL,
      realm: process.env.REACT_APP_KEYCLOAK_REALM,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    })
  : null;

let initPromise = null;

/** Инициализирует keycloak один раз. Возвращает true, если есть активная KC-сессия. */
export function initKeycloak() {
  if (!keycloakEnabled) return Promise.resolve(false);
  if (!initPromise) {
    // Отказ check-sso (браузер режет сторонние cookie, таймаут iframe) — это
    // «сессии нет», а не ошибка: без catch он уходил необработанным в консоль.
    initPromise = keycloak.init({
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      pkceMethod: 'S256',
      checkLoginIframe: false,
    }).catch((e) => {
      // Неверный realm или адрес тоже сюда — в консоли должна остаться причина.
      console.warn('[keycloak] init', e);
      return false;
    });
  }
  return initPromise;
}

export default keycloak;
